import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../../components/ad/ad';
import NotFound from '../../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../../components/loading_spinner/loading_spinner';
import ProductPost from '../../../../components/product_post/product_post';
import AllFeed from '../../../../components/all_feed/all_feed';
import { tagAllFeedAllStoriesRendered } from '../../../../../redux/action_creators/tag/tag_all_feed_action_creators';

// eslint-disable-next-line react/prefer-stateless-function
class Gift extends Component {
  render() {
    const { status, config, giftPage, gift, tagAllFeed } = this.props;

    if (status === 404) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (giftPage.isLoading) {
      return (
        <section className="product-page">
          <article className="product-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(giftPage, 'ads');

    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    // const product = this.props.product;
    const productName = `${get(gift, 'name')}`;

    return (
      <section className="product-page">
        <div className="post__article-top-ad-wrapper">
          <Ad
            {...combinedAdModel}
            name="flexiblepushdown"
            region="articletop"
          />
          <Ad
            {...combinedAdModel}
            name="mobileleaderboard"
            region="articletop"
          />
          <Ad {...combinedAdModel} name="oop" slug={false} oop />
        </div>

        <ProductPost
          config={config}
          product={gift}
          combinedAdModel={combinedAdModel}
          gift={true}
        />

        {get(tagAllFeed, 'posts[0]') ? (
          <AllFeed
            adModel={combinedAdModel}
            stories={get(tagAllFeed, 'posts')}
            allRendered={true}
            updateAction={tagAllFeedAllStoriesRendered}
            config={config}
            titleOverride={`Stories about ${productName}`}
          />
        ) : (
          ''
        )}

        <div className="product-page__ad-container">
          <Ad {...combinedAdModel} name="flexiblebillboard_1" />
          <Ad {...combinedAdModel} name="mobilerectangle_1" />
        </div>
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    gift: get(state, 'gift.data.rows[0]') || { error: true },
    giftPage: get(state, 'giftPage') || { error: true },
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
  };
}

Gift.propTypes = {
  config: PropTypes.shape({}),
  status: PropTypes.number,
  gift: PropTypes.shape({}).isRequired,
  giftPage: PropTypes.shape({
    ads: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }),
  tagAllFeed: PropTypes.shape({
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number,
    allRendered: PropTypes.bool,
    posts: PropTypes.arrayOf(PropTypes.shape({}))
  })
};

Gift.defaultProps = {
  config: {},
  status: 200,
  giftPage: {
    isLoading: false,
    error: false,
    errorMessage: ''
  },
  tagAllFeed: {
    posts: [{}],
    allRendered: false
  }
};

export default connect(mapStateToProps)(Gift);



// WEBPACK FOOTER //
// ./src/views/containers/pages/gift_guide/gift_page/gift_page.js